var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtml = function SvgHtml(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEEEF",
    d: "M6.1 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M18.1 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M22.6 10.5 18.1 6h4.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#84BD5A",
    d: "M19.6 19.5c0 .413-.337.75-.75.75H2.35a.75.75 0 0 1-.75-.75V12c0-.412.338-.75.75-.75h16.5c.413 0 .75.338.75.75z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.71 17.628v-3.406c0-.216.156-.372.425-.372.21 0 .366.156.366.372v1.308h1.955v-1.308c0-.216.192-.372.408-.372.21 0 .372.156.372.372v3.406c0 .21-.162.372-.372.372-.216 0-.408-.162-.408-.372v-1.312H3.501v1.312c0 .21-.156.372-.366.372-.269 0-.425-.162-.425-.372M8.2 14.6H7.15c-.522 0-.522-.767 0-.767h2.836c.534 0 .534.767 0 .767h-.995v3.028c0 .521-.792.534-.792 0V14.6M11.758 15.368v2.218c0 .265-.216.414-.432.414-.192 0-.36-.15-.36-.414V14.21a.4.4 0 0 1 .36-.415c.174 0 .276.103.378.217l1.32 1.78 1.366-1.847c.199-.245.684-.15.684.265v3.376c0 .265-.169.414-.36.414-.215 0-.384-.15-.384-.414v-2.218l-.995 1.259c-.215.265-.485.265-.683 0zM15.91 14.21c0-.198.167-.366.377-.366.192 0 .354.169.354.366v3.005h1.632c.587 0 .6.785 0 .785h-1.985c-.21 0-.378-.15-.378-.366z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M18.85 20.25H4.6V21h14.25c.413 0 .75-.337.75-.75v-.75c0 .413-.337.75-.75.75"
  })));
};
export default SvgHtml;